<template>
  <div class="content content_s">
    <div class="content">
      <div class="link-content">
        <span class="link-desc"> 链接:</span>
        <span class="link" v-for="(item, index) in QUICK" @click="open(item.websiteLink)" :key="index">{{ item.websiteName
        }}</span>
      </div>
    </div>
    <div class="content" style="background: #757575">
      <div class="link-content link-02-content">
        <div class="box mar90">
          <div class="box_web">
            <span>省政府及省直部门网站</span>
            <a-icon type="caret-up" class="icon" />
          </div>
          <div class="province w-100 province-one" style="left: 0">
            <p v-for="(item, index)  in PROVINCE" @click="open(item.websiteLink)" :key="index">
              {{ item.websiteName }}
            </p>
          </div>
        </div>
        <div class="box mar90">
          <div class="box_web">
            <span>市县外办网站</span>
            <a-icon type="caret-up" class="icon" />
          </div>
          <div class="province h-150" style="left: 320px">
            <p v-for="(item, index)  in CITY" @click="open(item.websiteLink)" :key="index">
              {{ item.websiteName }}
            </p>
          </div>
        </div>
        <!--        <div class="box">-->
        <!--          <span>-->
        <!--            <span>省（区市）外办网站</span>-->
        <!--            <a-icon type="caret-up" class="icon"/>-->
        <!--          </span>-->
        <!--          <div class="province" style="left: 401px;">-->
        <!--            <p v-for="item in REGION" @click="open(item.websiteLink)">{{ item.websiteName }}</p>-->
        <!--          </div>-->
        <!--        </div>-->
        <div class="box mar90">
          <div class="box_web">
            <span class="box-last">其他网站</span>
            <a-icon type="caret-up" class="icon" />
          </div>
          <div class="province" style="left: 655px">
            <p v-for="(item, index)  in OTHER" @click="open(item.websiteLink)" :key="index">
              {{ item.websiteName }}
            </p>
          </div>
        </div>
      </div>
    </div>
    <div class="middle">
      <!-- <img class="mark" src="../../assets/images/icon_bottom_party.png" alt="" /> -->
      <!-- <a href="https://bszs.conac.cn/sitename?method=show&id=0B2985CA9E2D203AE053012819AC55A7" target="_blank"> <img
          class="mark" src="../../assets/images/icon_bottom_company.png" alt="" /> </a> -->
          
      <span class="mark"  ref="jsContainer">
        <span id="_ideConac"></span>
      </span>

      <div class="box">
        <p>主办单位：福建省外事服务中心</p>
        <p>中文域名：福建省外事服务中心.公益</p>
        <p>中心地址：福州市华林路97号 邮政编码：350003</p>
        <p>建议使用1280*768以上分辨率显示器</p>
      </div>
      <!-- <img class="mark-01" src="../../assets/images/icon_bottom_tel.png" alt="" />
      <div class="box">400-918-2316</div> -->
      <div class="box">
        <img class="mark-02" src="../../assets/images/icon_bottom_qrcode_foreign_affairs.png" alt="" />
        <p class="p">福建外事微信订阅号</p>
      </div>
      <div class="box">
        <img class="mark-02" src="../../assets/images/icon_bottom_qrcode_foreign_service.png" alt="" />
        <p class="p1">福建外服微信公众号</p>
      </div>
    </div>
    <div class="bottom">
      <span> Copyright 2008-现在 ffasc.cn 福建省外事服务中心 </span>
      <img src="../../assets/images/icon_bottom_cnzz.png" />
      <a href="https://www.51.la/?comId=18756364" target="_blank"> <img src="../../assets/images/icon_bottom_51la.png" /></a>
      
      <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank"> 闽ICP备11002494号 </a>
    </div>
  </div>
</template>

<script>
import { getLinkList } from "@/api/footer.js";
export default {
  name: "footer",
  data() {
    return {
      QUICK: [],
      PROVINCE: [],
      CITY: [],
      REGION: [],
      OTHER: [],
      focus: "0",
      scriptLoaded: false, 
      html:''
    };
  },
  created() {
    this._getLinkList();
    
  },
  mounted() {
    this.loadExternalScript();
  },
  watch: {
    focus: function (val) {
      console.log(val, 111);
    },
  },
  methods: {
    loadExternalScript() {  
      const src =`https://dcs.conac.cn/js/14/000/0000/60382710/CA140000000603827100001.js`
      const script = document.createElement("script");
      script.src = src;
      this.$refs.jsContainer.appendChild(script);
      script.onload = () => {  
        this.scriptLoaded = true;
      };
    },  
    open(url) {
      window.open(url);
    },
    _getLinkList() {
      getLinkList().then((res) => {
        this.QUICK = this._.get(res, "data.records", []).filter(
          (item) => item.websiteType === "QUICK"
        );
        this.PROVINCE = this._.get(res, "data.records", []).filter(
          (item) => item.websiteType === "PROVINCE"
        );
        this.CITY = this._.get(res, "data.records", []).filter(
          (item) => item.websiteType === "CITY"
        );
        this.REGION = this._.get(res, "data.records", []).filter(
          (item) => item.websiteType === "REGION"
        );
        this.OTHER = this._.get(res, "data.records", []).filter(
          (item) => item.websiteType === "OTHER"
        );
      });
    },
    leave() {
      this.focus = "";
      console.log(this.focus, 213);
    },
  },
};
</script>

<style scoped lang='less'>
.content_s {
  position: relative;
  top: 0px;
  // z-index: -999;
}

.link-desc {
  width: 34px;
  height: 12px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: bold;
  color: #000000;
}

.link {
  width: 42px;
  height: 12px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #666666;
  margin-left: 25px;
  cursor: pointer;
}

.content {
  width: 100%;
  background: #dcdcdc;
}

.link-content {
  width: 1140px;
  padding: 14px 0 15px 0px;
  background: #dcdcdc;
  position: relative;
  /*left: 50%;*/
  /*transform: translateX(-50%);*/
  margin: auto;
  text-align: left;
}

.link-02-content {
  background: #757575;
  color: white;
}

.icon {
  cursor: pointer;
  // margin: 0 20px 0 87px;
  margin: 0 0 0 110px;
}

.icon::after {
  content: "";
  display: inline-block;
  width: 2px;
  height: 15px;
  background: white;
  margin-left: 20px;
}

.middle {
  padding-top: 16px;
  background: #f2f2f2;
}

.bottom {
  background: #f2f2f2;
  padding: 0 0 20px 0;

  &>img:nth-of-type(1) {
    width: 20px;
    height: 20px;
  }

  &>img:nth-of-type(2) {
    width: 36px;
    height: 20px;
  }
}

.mark {
  width: 64px;
  height: 64px;
  margin-right: 64px;
}

// .mark:first-of-type {
//   margin-right: 7px;
// }
.mark-01 {
  width: 60px;
  height: 60px;
  margin-right: 17px;
}

.mark-02 {
  width: 102px;
  height: 102px;
  margin-left: 63px;
}

.mark-02:last-of-type {
  margin-left: 47px;
}

.box {
  display: inline-block;
  vertical-align: middle;

  /* position: relative; */
  p {
    text-align: left;
  }

  .p {
    padding: 3px 0;
    margin-left: 45px;
  }

  .p1 {
    padding: 3px 0;
    margin-left: 47px;
  }
}

.province {
  position: absolute;
  bottom: 40px;
  left: 0;
  /* width: 100%; */
  background: white;
  padding: 13px 15px 0px 15px;
  color: black;
  z-index: 99999;
  display: none;
  flex-flow: column;
  flex-wrap: wrap;
  height: 225px;
  border: 1px solid #dcdcdc;

  >p {
    width: auto;
    cursor: pointer;
    display: inline-block;
  }
}

.province-one {
  align-content: flex-start;
  flex-direction: row;

  >p {
    flex: 0 0 14%;
  }
}

// .h-150 {
//   height: 180px;
// }
.box:hover .province {
  display: flex;
}

.w-100 {
  width: 100%;
}

.mar90 {
  margin-right: 90px;
}

.box_web {
  display: inline-block;
  padding-top: 4px;
}

.box>span {
  display: inline-block;
  text-align: left;
}

// .box .box-last {
//   margin-left: -50px;
// }
// /deep/ .ant-table-tbody:hover {
//   background-color: gray !important;
// }</style>



// WEBPACK FOOTER //
// src/components/index/footer.vue